import Header from '@components/Comman/Header'
import { Button, Checkbox, Form, GetProp, Input, Radio, Select, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getBusinessIReferAction, sendReferralAction } from '../../actions/refer';
import { businessDetailsAction, getAllRewards } from '../../actions/business';
import { SendOutlined } from '@ant-design/icons';
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';
// import { getRoleBasedReward } from '@utils/comman';

const ReferralAdd = ({isView = false}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
//   const [servicesList, setServicesList] = useState<any>([]);
  const [businessData, setBusinessData] = useState<any>();
  const { user } = useSelector((state: any) => state?.Auth);
//   const businessDetails = useSelector((state: any) => state?.Business?.businessDetails);
  const businessIReferList = useSelector((state: any) => state?.Business?.businessIReferList);
  const rewardList = useSelector((state:any)=> state?.Business?.rewardList)
  const userData = useSelector((state: any) => state?.Auth?.user?.user || state?.Auth?.user?.data);
  let stateData = location?.state;
  
  useEffect(()=> {
    dispatch(getBusinessIReferAction({ limit: 1000 }, ()=> {}));
    dispatch(getAllRewards({}, () => {}));
    const payload = {
        businessCode: userData?.businessCode
    }
    dispatch(
        businessDetailsAction(payload, (resp: any) => {})
    );

  }, [userData])

    let updatedRewardList = businessData?.business?.rewards?.length > 0 ?
        businessData?.business?.rewards?.map((item: any) => {
            if (item?.referrerRewardValue && item?.isActive) {
                return {
                    ...item,
                    label: item?.rewardName,
                    value: item?.id,
                }
            }
        }) : userData?.roleId === 2 ?
            rewardList?.data?.map((item: any) => {
                if (item?.referrerRewardValue && item?.isActive) {
                    return {
                        ...item,
                        label: item?.rewardName,
                        value: item?.id,
                    }
                }
            }) :
            [];


    let modifiedBusinessReferList = businessIReferList?.map((item: any) => {
        return {
            value: item?.senderCode,
            label: item?.business?.BusinessDetails?.businessName || item?.business?.businessDetails?.businessName,
        }
    });
    // ********* businesses refer list for business ***************** //
    userData?.roleId === 2 && modifiedBusinessReferList.push({
        label: userData?.businessDetails?.businessName,
        value: userData?.businessCode
    })
  

const isInitialSet = useRef(false);

useEffect(() => {
  if (
    !isInitialSet.current &&
    modifiedBusinessReferList?.length > 0
  ) {
    const defaultCode =
      userData?.businessCode ||
      modifiedBusinessReferList[0]?.value;

    form.setFieldsValue({
      businessCode: String(defaultCode),
    });

    isInitialSet.current = true; // prevent future resets
  }
}, [modifiedBusinessReferList]);

  const onFinish = (values: any) => {
    
      const selectedBusiness = modifiedBusinessReferList.find(
        (item:any) => item.value === values.businessCode
      );
    
      values.businessName = selectedBusiness?.label;   // for backend if needed
      values.businessCode = selectedBusiness?.value;   // actual senderCode
    
      let updatedServiceList = values?.reward?.map((item: any) => {
        let rewardPayload = {
            offerName: item.label,
            offerValue: +(item.referrerRewardValue),
            offerType: item.
            referrerRewardType,
            id: item.id,
    };

    if(!rewardPayload?.offerType) 
    delete rewardPayload?.offerType;
    if(!rewardPayload?.offerValue)
    delete rewardPayload?.offerValue

    return rewardPayload;
  });

  values.reward = updatedServiceList;

      dispatch(
       sendReferralAction(values, (resp: any) => {
         if (resp) {
           navigate('/my-referrals');
         }
       })
);
};
  const onFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
    // You can also display an error message to the user here
  };

const handleBusinessChange = (value: string) => {
  const selected = businessIReferList?.find(
    (item: any) => item?.senderCode === value
  );

  if (selected) {
    setBusinessData(selected);
  } else if (value === userData?.businessCode) {
    setBusinessData({
      ...userData,
      senderCode: userData?.businessCode,
    });
  }
};
  
  isView = stateData?.isView;
  const adminId = stateData?.adminId; //If opened from Global Admin
  
  
  useEffect(() => {
      updatedRewardList = businessData?.business?.rewards?.map((item: any) => {
          return {
                ...item,
                label: item?.rewardName,
                value: item?.id,
            }
        })
    }, [businessData])
  return (
      <div>
          <Header pagTitle={isView ? 'View Referral' : 'Send Referral'} />
          <div className="contentBody">
              <div className="bodycard">
                  <div className="bodycardheading">
                      <div className="mobileView buttonsvgs" onClick={()=> navigate(-1)}>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="25"
                              viewBox="0 0 24 25"
                              fill="none"
                          >
                              <rect
                                  x="0.4"
                                  y="1.18168"
                                  width="23.2"
                                  height="23.2"
                                  rx="11.6"
                                  stroke="#F47523"
                                  strokeWidth="0.8"
                              />
                              <path
                                  d="M14 8.78168L10 12.7817L14 16.7817"
                                  stroke="#F47523"
                                  strokeWidth="1.25"
                                  strokeLinecap="round"
                              />
                          </svg>
                      </div>
                      {isView ? 'View' : 'Send'} Referral
                  </div>
                  <div className="cardContentbody">
                      <Form
                          className="formControl"
                          layout="vertical"
                          form={form}
                          onFinish={onFinish}
                          onFinishFailed={onFailed}
                          initialValues={{
                            //   businessCategory: userData?.businessCategory,
                              businessCode: stateData?.data?.businessCode || userData?.businessCode,
                              firstName: stateData?.data?.firstName ?? '',
                              lastName: stateData?.data?.lastName ?? '',
                              email: stateData?.data?.email ?? '',
                              mobileNumber: stateData?.data?.mobileNumber ?? '',
                              hasSpoken: stateData?.data?.hasSpoken ?? undefined,
                              reward: stateData?.data?.reward || [],
                          }}
                      >
                          <div className="row">
                              <div className="col-lg-12 col-sm-12">
                                  <Form.Item
                                      className="formControlDesign"
                                      label="Business Name"
                                      name="businessCode"
                                      rules={[
                                        {
                                            required: true,
                                            message: 'Please select business!',
                                        }
                                      ]}
                                  >
                                      <Select
                                          className="searchselects"
                                          disabled={isView ? true : false} // Ensure disabled is a boolean value
                                          placeholder="Business Name"
                                          onChange={(value) => 
                                            handleBusinessChange(value)
                                        } // Simplify the onChange handler
                                      >
                                          {modifiedBusinessReferList?.map((item:any, index:number) => {
                                              return (
                                                  <Select.Option key={index} value={item.value}>
                                                      {item.label}
                                                  </Select.Option>
                                              );
                                          })}
                                      </Select>
                                  </Form.Item>
                              </div>
                              <div className="col-lg-6 col-sm-12">
                                  <Form.Item
                                      className="formControlDesign"
                                      label="First Name"
                                      name="firstName"
                                      rules={[
                                          {
                                              required: true,
                                              message:
                                                  'Please input your First Name!',
                                          },
                                      ]}
                                  >
                                      <Input
                                          disabled={isView}
                                          placeholder="Enter First Name"
                                      />
                                  </Form.Item>
                              </div>
                              <div className="col-lg-6 col-sm-12">
                                  <Form.Item
                                      className="formControlDesign"
                                      label="Last Name"
                                      name="lastName"
                                      rules={[
                                          {
                                              required: true,
                                              message:
                                                  'Please input your Last Name!',
                                          },
                                      ]}
                                  >
                                      <Input
                                          disabled={isView}
                                          placeholder="Enter Last Name"
                                      />
                                  </Form.Item>
                              </div>
                              <div className="col-lg-6 col-sm-12">
                                  <Form.Item
                                      className="formControlDesign"
                                      label="Email"
                                      name="email"
                                      rules={[
                                          {
                                              required: true,
                                              type: 'email',
                                              message:
                                                  'Please input a valid email!',
                                          },
                                      ]}
                                  >
                                      <Input
                                          disabled={isView}
                                          placeholder="Enter Email"
                                      />
                                  </Form.Item>
                              </div>
                              <div className="col-lg-6 col-sm-12">
                                <CustomPhoneNumber isRequired={true} label="Contact Number" name="mobileNumber" />
                              </div>
                              <div className="col-lg-12 col-sm-12">
                                <Form.Item
                                    className="formControlDesign"
                                    name="hasSpoken"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select an option!',
                                        },
                                    ]}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        <span style={{ color: '#000', fontSize: '14px' }}>
                                            <span style={{ color: '#ff4d4f', marginRight: '4px' }}>*</span>
                                            Have you spoken to them about us?
                                        </span>
                                        <Radio.Group disabled={isView} style={{ display: 'flex', gap: '20px' }}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </Radio.Group>
                                    </div>
                                </Form.Item>
                            </div>
                            <div className="col-lg-12 col-sm-12">
                                <Form.Item
                                      className="formControlDesign"
                                      label="Comment"
                                      name="comment"
                                      rules={[
                                          {
                                              required: true,
                                              message:
                                                  'Please input your Comment!',
                                          },
                                      ]}
                                  >
                                      <Input.TextArea
                                          disabled={isView}
                                          placeholder="Enter Comment (max 250 characters)"
                                          maxLength={250}
                                      />
                                  </Form.Item>
                              </div>
                                      
                              {updatedRewardList?.length > 0 ?
                                  <div className="col-lg-6 col-sm-12">
                                      <Form.Item
                                          name="reward"
                                          label="Services"
                                          rules={[
                                              {
                                                  required: false,
                                                  message: 'Please select reward!',
                                              },
                                          ]}
                                      >
                                          <Checkbox.Group style={{ width: '100%', padding: '10px 10px 10px 0px' }}>
                                              {updatedRewardList?.map((item: any, index: number) => {
                                                  return item?.label && <Checkbox disabled={isView} key={index} value={item} style={{ marginBottom: '10px' }}>
                                                      <span style={{ marginBottom: '10px' }}>
                                                          {item?.label}
                                                      </span>
                                                  </Checkbox>
                                              })}
                                          </Checkbox.Group>
                                      </Form.Item>
                                  </div>
                               : ""}

                              <div className="col-lg-12 mt-15">
                                  <div className="text-end btn-groups-Forms">
                                      <button
                                          className="btn btn-outline-primary"
                                          onClick={() =>{
                                            userData?.roleId === 1 ? navigate('/view-business-details', {state: {adminId}}):(
                                                isView
                                                ? navigate('/my-referrals')
                                                : navigate('/dashboard')
                                            )
                                          }}
                                      >
                                          Cancel
                                      </button>
                                    
                                      {!isView && (
                                          <Button
                                              className="btn btn-primary"
                                              type="primary"
                                              onClick={() => form.submit()}
                                          >
                                              Send <SendOutlined />
                                          </Button>
                                      )}
                                  </div>
                              </div>
                          </div>

                      </Form>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default ReferralAdd